import axiosInstance from "../../../utils/axios";

const path = "common";

export const getCMSPage = async (slug) => {
    return await axiosInstance().get(`${path}/cms-page?slug=${slug}`);
};

export const submitContactUs = async (values) => {
    return await axiosInstance().post(`${path}/contact-us`, values);
};
